var map = {
	"./beaker-blue-dark.png": "e1bd",
	"./beaker-blue-light.png": "956c",
	"./beaker-blue.png": "e387",
	"./beaker-clear.png": "468a",
	"./beaker-green-dark.png": "e2db",
	"./beaker-green.png": "9426",
	"./beaker-red.png": "1a9a",
	"./beaker-teal-greener.png": "e8ee",
	"./beaker-teal.png": "a9ab",
	"./bubbles-s.gif": "db30",
	"./bubbles3.gif": "ecfd",
	"./copper-degraded.png": "e019",
	"./copper-mini.png": "b2a0",
	"./copper.png": "c146",
	"./gray-01-mini.png": "d36b",
	"./gray-02-mini.png": "3db7",
	"./gray-03-mini.png": "3d56",
	"./gray-dark-01-mini.png": "471b",
	"./gray-dark-02-mini.png": "c2c6",
	"./iron-degraded.png": "f0da",
	"./iron.png": "1a1e",
	"./lead-crispy.png": "6c6e",
	"./lead-degraded.png": "4595",
	"./lead.png": "54ea",
	"./magnesium-degraded.png": "96de",
	"./magnesium.png": "78b2",
	"./nickel-degraded.png": "fd01",
	"./nickel.png": "c7d8",
	"./silver-degraded.png": "406a",
	"./silver-mini.png": "8e3c",
	"./silver.png": "2231",
	"./tin-degraded.png": "7a89",
	"./tin.png": "f7a2",
	"./zinc-degraded.png": "e214",
	"./zinc.png": "65ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";